import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import Reveal from "@/components/Reveal";

function Card({ s, className = "" }) {
  return (
    <Reveal
      className={`group relative bg-[#0E1213] border border-[#27272A] hover:border-[#3FB8DC]/60 transition-all duration-500 overflow-hidden ${className}`}
    >
      <div data-testid={`service-card-${s.id}`} className="h-full">
        <div className="zoom-wrap relative h-56 md:h-64 overflow-hidden bg-[#080A0B]">
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0E1213] via-transparent to-transparent" />
          <div className="absolute top-5 left-5 font-serif-display text-5xl text-[#F4F0EB]/30">
            {s.no}
          </div>
        </div>
        <div className="p-8 md:p-10">
          <h3 className="font-serif-display text-2xl md:text-3xl text-[#F4F0EB] mb-4 leading-tight">
            {s.title}
          </h3>
          <p className="text-[#A1A1AA] text-sm md:text-base leading-relaxed font-light">
            {s.desc}
          </p>
          <div className="mt-8 flex items-center gap-2 text-[#3FB8DC] text-xs tracking-[0.2em] uppercase">
            <span>Enquire</span>
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </div>
        </div>
      </div>
    </Reveal>
  );
}

export default function Services() {
  return (
    <section
      data-testid="services-section"
      id="services"
      className="relative bg-[#080A0B] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-10 h-px bg-[#3FB8DC]" />
            <span className="eyebrow">Capabilities</span>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end mb-16 lg:mb-20">
          <Reveal delay={100} className="lg:col-span-8">
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] leading-[1.02] tracking-tight">
              Seven disciplines.
              <br />
              <span className="italic text-[#A1A1AA]">One careful trade.</span>
            </h2>
          </Reveal>
          <Reveal delay={220} className="lg:col-span-4">
            <p className="text-[#A1A1AA] text-base leading-relaxed">
              We work across multiple areas of plumbing, but approach every job
              with the same level of care, skill and attention to detail.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Hero card spans 2 */}
          <Card s={SERVICES[0]} className="md:col-span-2" />
          <Card s={SERVICES[1]} />
          <Card s={SERVICES[2]} />
          <Card s={SERVICES[3]} />
          <Card s={SERVICES[4]} className="md:col-span-2" />
          <Card s={SERVICES[5]} />
          <Card s={SERVICES[6]} className="md:col-span-2 lg:col-span-2" />
        </div>
      </div>
    </section>
  );
}
